export default __webpack_public_path__ + "static/media/robot4.986693db.jpg";